export default __webpack_public_path__ + "static/media/templates_pink.56d7c0bb.svg";